import { districts } from './districts'

export const searchConfig = {
	defaultZone: 'paris' as const,
	districts,
	timeSlot: {
		max: '23:00',
		min: '08:00',
	},
	timeSlots: [
		'08:00',
		'08:30',
		'09:00',
		'09:30',
		'10:00',
		'10:30',
		'11:00',
		'11:30',
		'12:00',
		'12:30',
		'13:00',
		'13:30',
		'14:00',
		'14:30',
		'15:00',
		'15:30',
		'16:00',
		'16:30',
		'17:00',
		'17:30',
		'18:00',
		'18:30',
		'19:00',
		'19:30',
		'20:00',
		'20:30',
		'21:00',
		'21:30',
		'22:00',
		'22:30',
		'23:00',
		'23:30',
	],
	zones: {
		lyon: {
			bounds: {
				neLat: 45.79472440134,
				neLng: 4.850987637938311,
				swLat: 45.74071912703303,
				swLng: 4.813594962061694,
			},
			center: { lat: 45.7603831, lng: 4.849664 },
			latitude: 45.7603831,
			longitude: 4.849664,
			zoom: { max: 14, min: 2, search: { desktop: 11, mobile: 11 }, space: 14 },
		},
		london: {
			bounds: {
				neLat: 51.68,
				neLng: 0.35,
				swLat: 51.28,
				swLng: -0.55,
			},
			center: { lat: 51.5074, lng: -0.1278 },
			latitude: 51.5074,
			longitude: -0.1278,
			zoom: {
				max: 17,
				min: 2,
				search: { desktop: 11, mobile: 10.5 },
				space: 17,
			},
		},
		paris: {
			bounds: {
				neLat: 48.920901,
				neLng: 2.433631,
				swLat: 48.793276,
				swLng: 2.206351,
			},
			center: { lat: 48.8589, lng: 2.3204 },
			latitude: 48.8570885,
			longitude: 2.319991,
			zoom: {
				max: 17,
				min: 2,
				search: { desktop: 11, mobile: 10.5 },
				space: 17,
			},
		},
	} as const,
}
